import { Injectable, Inject } from '@angular/core'
import { Subject, Observable } from 'rxjs/Rx'
import { APP_CONFIG, IAppConfig } from '../../app.config'
import { Http, Response, URLSearchParams } from '@angular/http'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Helpers } from './helpers'
import { TokenBase } from './token-base'
import { NgxPermissionsService } from 'ngx-permissions'
import { AuthHttp } from 'angular2-jwt';
import { RefreshTokenService } from './refresh-token.service'

@Injectable()
export class LoginService extends TokenBase {
    /*
        offset seconds
    */
    private offsetSeconds: number = 30;

    constructor(public http: HttpClient, @Inject(APP_CONFIG) public config: IAppConfig, public permissionsService: NgxPermissionsService, private refreshTokenService: RefreshTokenService) {
        super(http, config, permissionsService);
    }

    public signin(token: string): Observable<Response> {
        this.signout();
        let tokenEndpoint: string = this.config.apiEndpoint + 'AccessToken';

        const request: any = {
            token: token
        };    

        return this.http.post(tokenEndpoint, request)
            .map((res: any) => {
                const body: any = res;

                if (body.canLogin) { //loging success
                    // Stores access token & refresh token.
                    this.store(body);

                    // Tells all the subscribers about the new status.
                    this.signinSubject.next(true);
                }

                return body;

            }).catch((error: any) => {
                return Observable.throw(error);
            });
    }

    public signout(): void {
        this.redirectUrl = null;

        // Unschedules the refresh token.
        this.unscheduleRefresh();

        // Revokes tokens.
        this.revokeToken();
        this.revokeRefreshToken();
    }


    retrieveUserType() {
        const path = this.config.apiEndpoint + "User/";
        return this.http.get(path).map((response: any) => { return response; }).catch(this.handleError);
    }
}